if (!customElements.get('gltheaa-snap-gallery')) {
  class GltheaaSnapGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-snap-track]');
      if (!this.track || this.track.children.length < 2) return;

      const prev = document.createElement('button');
      const next = document.createElement('button');
      prev.type = 'button';
      next.type = 'button';
      prev.className = 'gltheaa-snap-gallery__nav gltheaa-snap-gallery__nav--prev';
      next.className = 'gltheaa-snap-gallery__nav gltheaa-snap-gallery__nav--next';
      prev.setAttribute('aria-label', this.getAttribute('data-label-prev') || 'Previous');
      next.setAttribute('aria-label', this.getAttribute('data-label-next') || 'Next');
      prev.addEventListener('click', () => this.scrollBy(-1));
      next.addEventListener('click', () => this.scrollBy(1));
      this.append(prev, next);
    }

    scrollBy(direction) {
      if (!this.track) return;
      this.track.scrollBy({
        left: direction * this.track.clientWidth,
        behavior: 'smooth',
      });
    }
  }

  customElements.define('gltheaa-snap-gallery', GltheaaSnapGallery);
}
